import Glide from "@glidejs/glide";
import { getElements, ifSelectorExist } from "./utils";

export const christianSliders = () => {

  const reviewssSlider = ".reviews_slider";
  if (ifSelectorExist(reviewssSlider)) {
    Array.from(getElements(reviewssSlider)).forEach((item) => {
      new Glide(item, {
        gap: 50,
        perView: 2,
        type: "carousel",
        swipeThreshold: false, 
        dragThreshold: false,
        breakpoints: {
          768: {
            swipeThreshold: true, 
            dragThreshold: true,
            perView: 1,
          },
        },
      }).mount();
    });
  }

  const coupons_glide = ".christian_coupons_slider";
  if (ifSelectorExist(coupons_glide)) {
    Array.from(getElements(coupons_glide)).forEach((item) => {
      new Glide(item, {
        perView: 1,
        type: "slider",
        animationDuration: 1000,
        autoplay: 0,
      }).mount();
    });
  }
};
